import {formatNumberChart, getLabels, groupBy} from "../../utility/Utils";

const DEVICE_LABELS = {
    fr: { desktop: 'Ordinateur', mobile: 'Mobile', phone: 'Téléphone', tablet: 'Tablette', others: 'Autres', '': 'Inconnu' },
    en: { desktop: 'Desktop', mobile: 'Mobile', phone: 'Phone', tablet: 'Tablet', others: 'Others', '': 'Unknown' },
};

const OS_LABELS = {
    fr: { others: 'Autres', '': 'Inconnu' },
    en: { others: 'Others', '': 'Unknown' },
};

const translateDevice = (label, language) => DEVICE_LABELS[language]?.[label] ?? label;
const translateOs = (label, language) => OS_LABELS[language]?.[label] ?? label;

export const transChart = (values, unit, startDate, key, language = 'en') => {
    if (!values) return {unit, labels: [], datasets: []};

    const translate = key === 'device' ? translateDevice : translateOs;

    // FIXME: data should be treated in backend
    const tmpDevicePerOsGroupedByHour = groupBy(values, unit);
    const tmpDevicePerOsGroupedByLabel = groupBy(values, key);
    const labels = getLabels(Object.keys(tmpDevicePerOsGroupedByHour), startDate, unit, values);

    const datasets = Object.entries(tmpDevicePerOsGroupedByLabel).map(([key1, value]) => ({
        label: translate(key1, language),
        data: Object.entries(tmpDevicePerOsGroupedByHour).map(([key2, value2]) =>
            value2.find(item => item[key] === key1)?.count_sale ?? null
        ),
    }));

    return {unit, labels, datasets};
};

export const transPercentPerDeviceChart = (values, language = 'en') => {
    return {
        labels: values ? values.map((item) => translateDevice(item.device, language) + ' \n ' + formatNumberChart(item.percent, 'percentage')) : [],
        datasets: {data: values ? values.map((item) => item.percent) : []},
    }
}
